<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ch4"> </p>
<p class="img"><img alt="image" height="360" src="images/pg-12.jpg" width="372"/></p>
<p class="half-space"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?6a31a78e